import { GridRequest } from 'projects/app-core/src/models/gridRequest';
import { GridResponse } from 'projects/app-core/src/models/gridResponse';

export interface LyfisQuestionsGridRequest
  extends GridRequest<
    LyfisQuestionsSort,
    LyfisQuestionsFilter,
    LyfisQuestionsSearch,
    LyfisQuestionsDateFilter
  > { }

export enum LyfisQuestionsSort {
  ORDER = 'order',
  INTERNAL_LABEL = 'internalLabel',
  CATEGORY = 'category',
  ACTIVE = 'active',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'lastModifiedAt',
}

export enum LyfisQuestionsFilter {
  ACTIVE = 'active',
  CATEGORY_ID = 'categoryId',
  ANSWER_TYPE = 'answerType',
  IS_STATIC_PROFILE = 'isStaticProfile',
  DISEASE_ID = 'diseaseId',
}

export enum LyfisQuestionsDateFilter {
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'lastModifiedAt',
}

export enum LyfisQuestionsSearch {
  INTERNAL_LABEL = 'internalLabel',
  QUESTION = 'question',
  CATEGORY = 'category',
  FACT_KEY = 'factKey',
}

export enum AnyoSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface DateRange {
  from: Date;
  to?: Date;
}

export interface LyfisQuestionsGridResponse
  extends GridResponse<LyfisQuestionsFilterData | undefined, LyfisQuestion> { }

export interface LyfisQuestionsFilterData {
  active?: boolean[];
  categoryId?: string[];
  answerType?: LyfisAnswerType[];
  isStaticProfile?: boolean[];
}

export enum LyfisAnswerType {
  NUMERIC = 'numeric',
  OPTIONS = 'options',
  YES_NO = 'yes_no',
  DERIVED = 'derived',
  DATE = 'date',
  TEXT_BOX = 'text_box',
  ARRAY = 'array',
}

export interface LyfisQuestion {
  _id?: string;
  internalLabel: string;
  label: string;
  order: number;
  diseaseIds: string[];
  question: string;
  questionDescription?: string;
  categoryId: string;
  category: string;
  answerType: LyfisAnswerType;
  factId: string;
  factKey: string;
  unit: string;
  options?: { key: string; label: string; order: number; isDefault?: boolean }[];
  validation?: { min: number; max: number; regex: string };
  active: boolean;
  isStaticProfile?: boolean;
  cadence?: {
    minIntervalDays?: number;
    critical?: boolean;
    required?: boolean;
  };
  placeholder?: string;
  arrayDefinitions?: ArrayDefinition[];
  createdAt?: string;
  lastModifiedAt?: string;
}

export interface ArrayDefinition {
  placeHolder: string;
  factKey: string;
  validation?: {
    min: number;
    max: number;
    regex: string;
  };
}
